import useSettings from './useSettings';

export default useSettings;
